import React from 'react';
import { useSelector } from 'react-redux';
import pluralize from 'pluralize';
import { format as formatDate, differenceInDays } from 'date-fns';
import { Flex, Box, Text, Heading } from 'roo-ui/components';
import Image from 'components/Image';
import { getStayDates, getOccupants, getProperty, getCancellationPolicy } from 'store/quote/quoteSelectors';
import { DISPLAY_DATE_FORMAT } from 'config';
import OccupantsSummary from 'components/OccupantsSummary';
import CancellationRefundModal from 'components/CancellationRefundModal';

const BookingSummary = () => {
  const property = useSelector(getProperty);
  const occupants = useSelector(getOccupants);
  const cancellationPolicy = useSelector(getCancellationPolicy);
  const { checkIn, checkOut } = useSelector(getStayDates);

  const numberOfNights = differenceInDays(checkOut, checkIn);
  const formattedCheckIn = formatDate(checkIn, DISPLAY_DATE_FORMAT);
  const formattedCheckOut = formatDate(checkOut, DISPLAY_DATE_FORMAT);

  const { urlMedium, urlLarge, caption } = property.mainImage || {};

  const propertyImageSrcSet = `${urlLarge} 2x, ${urlMedium} 1x`;

  return (
    <Flex border={1} borderColor="greys.alto" borderRadius="default" overflow="hidden">
      <Box display={['none', 'block']} width="190px">
        <Image height="170px" lazy src={urlMedium} alt={caption} srcSet={propertyImageSrcSet} />
      </Box>
      <Box m={[3, 6]}>
        <Box>
          <Heading.h4 data-testid="property-name">{property.name}</Heading.h4>
        </Box>
        <Box>
          <Text fontSize={['sm', 'base']} data-testid="check-in">
            {formattedCheckIn}
          </Text>{' '}
          -
          <Text fontSize={['sm', 'base']} data-testid="check-out">
            {formattedCheckOut}
          </Text>{' '}
          <Text fontSize={['sm', 'base']} data-testid="nights">
            ({pluralize('night', numberOfNights, true)})
          </Text>
        </Box>
        <Box>
          <OccupantsSummary fontSize={['sm', 'base']} occupants={occupants} />
        </Box>
        <Box>
          <CancellationRefundModal cancellationPolicy={cancellationPolicy} hideBeforeDate fontSize={['sm', 'base']} />
        </Box>
      </Box>
    </Flex>
  );
};

export default BookingSummary;
